import { IDoorAssessment, DoorAssessment } from '../../common/door-assessment';
import { IDiscountRequest, DiscountRequest } from './discount-request';
import { IDoorTypeOption, DoorTypeOption } from '../../common/door-type-option';
import { IDoorSizeOption, DoorSizeOption } from '../../common/door-size-option';
import { IDoorHandingOption, DoorHandingOption } from '../../common/door-handing-option';
import { IStandardMaterial, StandardMaterial } from '../../common/standard-material';
import { IStandardLabor, StandardLabor } from '../../common/standard-labor';

export interface IProjectAssessmentEditingModel {
    dateScheduled: number;
    datePerformed: number;
    commuteTimeBlocks: number;
    taxExemptionFormUrl: string;
    installationAssessments: IDoorAssessment[];
    discounts: IDiscountRequest[];
    notes: string;
    doorTypeOptions: IDoorTypeOption[];
    doorSizeOptions: IDoorSizeOption[];
    doorHandingOptions: IDoorHandingOption[];
    standardMaterialOptions: IStandardMaterial[];
    standardLaborOptions: IStandardLabor[];
}


export class ProjectAssessmentEditingModel implements IProjectAssessmentEditingModel {
    public dateScheduled: number = 0;
    public datePerformed: number = 0;
    public commuteTimeBlocks: number = 0;
    public taxExemptionFormUrl: string = '';
    public installationAssessments: IDoorAssessment[] = [];
    public discounts: IDiscountRequest[] = [];
    public notes: string = '';
    public doorTypeOptions: IDoorTypeOption[] = [];
    public doorSizeOptions: IDoorSizeOption[] = [];
    public doorHandingOptions: IDoorHandingOption[] = [];
    public standardMaterialOptions: IStandardMaterial[] = [];
    public standardLaborOptions: IStandardLabor[] = [];
}


